export const TOGGLE_MENU = 'TOGGLE_MENU'
export const TOGGLE_FLOATING_MENU = 'TOGGLE_FLOATING_MENU'

export const toggleMenu = () => {
    return {type: TOGGLE_MENU}
}

export const toggleFloatingMenu = () => {
    return {type: TOGGLE_FLOATING_MENU}
}



// WEBPACK FOOTER //
// ./src/actions/menu.js